<template>
  <div class="c-app flex-row align-items-center bo">
<!--    <CContainer>-->
<!--      <CRow class="justify-content-center">-->
<!--        <CCol md="9">-->
<!--          <CCardGroup>-->
<!--            <CCard class="p-4">-->
<!--              <CCardBody>-->
<!--                <CForm>-->
<!--                  <div class="text-center mb-3">-->
<!--                    <img src="@/assets/logo.svg" height="150px"/>-->
<!--                  </div>-->
<!--&lt;!&ndash;                  <h1>Login</h1>&ndash;&gt;-->
<!--                  <p class="text-muted text-center">เข้าระบบโดยใช้ Username และ Password <br> ของระบบบริหารงานทรัพยากรบุคคล  </p>-->
<!--                  <CInput-->
<!--                    v-model="username"-->
<!--                    placeholder="Username"-->
<!--                    autocomplete="username email"-->
<!--                  >-->
<!--                    <template #prepend-content><CIcon name="cil-user"/></template>-->
<!--                  </CInput>-->
<!--                  <CInput-->
<!--                    v-model="password"-->
<!--                    placeholder="Password"-->
<!--                    type="password"-->
<!--                    autocomplete="curent-password"-->
<!--                  >-->
<!--                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>-->
<!--                  </CInput>-->
<!--                  <CRow>-->
<!--                    <CCol  class="text-right">-->
<!--                      <CButton color="danger" class="px-4 w-50" @click="onAuthen">Login</CButton>-->
<!--                    </CCol>-->
<!--                  </CRow>-->
<!--                </CForm>-->
<!--              </CCardBody>-->
<!--            </CCard>-->
<!--            <CCard-->
<!--              color="danger"-->
<!--              text-color="white"-->
<!--              class=" py-5 d-md-down-none"-->
<!--              body-wrapper-->
<!--            >-->
<!--              <CCardBody>-->
<!--                <p class="font-weight-bold">1 Contact</p>-->
<!--                <p>ส่วนการเจ้าหน้าที่ (Personnel Division) Tel 0-5391-6494 , 6053  E-mail: personnel@mfu.ac.th</p>-->


<!--                <p class="font-weight-bold">2. คู่มือสมรรถนะ พนักงานมหาวิทยาลัยแม่ฟ้าหลวง</p>-->
<!--                <span>คู่มือ(TH) <a class="font-weight-bold" target="_blank" href="https://drive.google.com/file/d/1obIc3c5kEJ6nP1rBH5uA9nvw62fjzTid/view?usp=sharing ">"Click Here"</a></span> <br>-->
<!--                <span>คู่มือ(EN) <a class="font-weight-bold" target="_blank" href="https://drive.google.com/file/d/1Ds3wv_QlPoA_M10i2snrzrh5Ri_Qi9wQ/view?usp=sharing ">"Click Here"</a></span>-->

<!--                &lt;!&ndash;                <p class="font-weight-bold">3. Hashtag(#) Information <a class="font-weight-bold" target="_blank" href="https://drive.google.com/file/d/1k-aHNdibv6_cT2E3_S4atAuusV7-7TQM/view?usp=sharing">"Click Here"</a></p>&ndash;&gt;-->
<!--                &lt;!&ndash;                <p>Contact : MLII </p>&ndash;&gt;-->
<!--                &lt;!&ndash;                <p>Tel : 0-5391-8061</p>&ndash;&gt;-->

<!--                &lt;!&ndash;                <p class="font-weight-bold">4. Report Issues</p>&ndash;&gt;-->
<!--                &lt;!&ndash;                <p>Contact us <a class="font-weight-bold" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSeNPHQ-WBk-w1tv3IjBsDr7zJ_GoOh-oui-ctRhIl_LK00PzQ/viewform">"Click Here"</a></p>&ndash;&gt;-->

<!--                <p class="font-weight-bold mt-4">3. แจ้งปัญหาการเข้าใช้ระบบ <a class="font-weight-bold" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSec2LSaDE1flmQULhl7bsCbTOZl4nd1VGfSv3LDxP7bnuZ9iQ/viewform ">"Click Here"</a></p>-->

<!--&lt;!&ndash;                <p class="font-weight-bold">4. MFU-TQF Information: VDO Tutorial, Calendar <a class="font-weight-bold" target="_blank" href="https://qa.mfu.ac.th/qa-5645/qa-5663.html">"Click Here"</a></p>&ndash;&gt;-->

<!--              </CCardBody>-->
<!--            </CCard>-->
<!--          </CCardGroup>-->
<!--        </CCol>-->
<!--      </CRow>-->
<!--    </CContainer>-->
    <SignIn/>
    <CenterLoading/>
    <DialogMessage/>

  </div>

</template>
<script>
  import {mapGetters} from 'vuex'
  import CenterLoading from "@/projects/components/Dialog/CenterLoading";
  import DialogMessage from "@/projects/components/Dialog/DialogMessage";
  import SignIn from "@/projects/components/Dialog/SignIn";
  export default {
    name: 'Login',
    components: {SignIn, DialogMessage, CenterLoading},
    data () {
      return {
        username:'',
        password:'',
        // username:'52340023',
        // password:'52340023',
        dialog : {
          statue:false,
          title:"",
          message:""
        }

      }
    },

    mounted() {
      // localStorage.setItem('test','123444')

    },

    created() {
      // var storageHost = createHost([
      //   {
      //     origin: 'http://localhost:8080',
      //     allowedMethods: ['get', 'set', 'remove'],
      //   },
      //   {
      //     origin: 'http://localhost:8081',
      //     allowedMethods: ['get', 'set', 'remove'],
      //   },
      // ]);
      // var bazStorage = createGuest('http://localhost:8080/#/pages/login');
      //
      // // var bazStorage = createGuest(window.location.href === 'http://localhost:8080/#/pages/login'?'http://localhost:8081/#/pages/login':'http://localhost:8080/#/pages/login' );
      // bazStorage.get('tests', function(error, value) {
      //   // value for the key of 'fizz' will be retrieved from localStorage on www.baz.com
      //   console.log("practice",error,value)
      // });
    },

    beforeDestroy() {

    },

    methods: {
      onAuthen() {
        // const authCode = await this.$gAuth.getAuthCode()
        // console.log('authCode', authCode)

        // const googleUser = await this.$gAuth.signIn();
        // console.log('googleUser', googleUser)


        // this.login();

        var body = {};
        body.username = this.username;
        body.password = this.password;
        this.$store.dispatch("auth/singin", body)

      },

      async handleClickSignIn(){
        try {
          const googleUser = await this.$gAuth.signIn();
          this.isSignIn = this.$gAuth.isAuthorized
        } catch (error) {
          // On fail do something
          return null;
        }
      },
      login() {
        // googleSdkLoaded(google => {
        //   google.accounts.oauth2
        //       .initCodeClient({
        //         client_id: "225788483142-8pkg8on8nh60ao83ve33ff3lflv2ccvo.apps.googleusercontent.com",
        //         scope: "email profile openid",
        //         redirect_uri: "http://localhost:4000/auth/callback",
        //         callback: response => {
        //           console.log(response)
        //           // if (response.code) {
        //           //   this.sendCodeToBackend(response.code);
        //           // }
        //         }
        //       })
        //       .requestCode();
        // });
      },
    },

    computed:{
      ...mapGetters({
        // objJwt:'auth/objJwt',
        // dialogError:"auth/dialogError"
      })
    },

    watch: {
      objJwt:function (data) {

      },
      dialogError:function (data) {
        this.dialog = data
      }
    }
  }

</script>

<style>
.bo {
  background-color: #321FDB;
  background-image: url("../../assets/bg.jpeg");
  /*background-size: auto;*/

  height: 100vh;
  background-size: 110% 110%;
  background-position: center center;
  animation: shrink 50s infinite alternate;
}

.bos {
  height: 100%;
  /* max-height: 600px; */
  width: 100%;
  background-color: hsla(200, 40%, 30%, .4);
  background-image: url("../../assets/bg.jpeg");
  /*url('https://78.media.tumblr.com/66445d34fe560351d474af69ef3f2fb0/tumblr_p7n908E1Jb1uy4lhuo1_1280.png'),*/
  /*url('https://78.media.tumblr.com/8cd0a12b7d9d5ba2c7d26f42c25de99f/tumblr_p7n8kqHMuD1uy4lhuo2_1280.png'),*/
  /*url('https://78.media.tumblr.com/5ecb41b654f4e8878f59445b948ede50/tumblr_p7n8on19cV1uy4lhuo1_1280.png'),*/
  /*url('https://78.media.tumblr.com/28bd9a2522fbf8981d680317ccbf4282/tumblr_p7n8kqHMuD1uy4lhuo3_1280.png');*/
  /*background-repeat: repeat-x;*/
  /*background-position: 0 20%,*/
  /*0 100%,*/
  /*0 0;*/
  /*background-size: 2500px,*/
  /*800px,*/
  /*500px 200px,*/
  /*1000px,*/
  /*400px 260px;*/
  /*animation: 50s para infinite linear;*/
}
/*@keyframes shrink {*/
/*  0% {*/
/*    background-size: 120% 120%;*/
/*  }*/
/*  100% {*/
/*    background-size: 100% 100%;*/
/*  }*/
/*}*/
/*@keyframes para {*/
/*  100% {*/
/*    background-position: -5000px 20%,*/
/*    -800px 95%,*/
/*    500px 50%,*/
/*    1000px 100%,*/
/*    400px 0;*/
/*  }*/
/*}*/
</style>
